import psl, { ParsedDomain } from 'psl';

/**
 * Extract the second level domain from the current location.
 * For example, extract "deepc-engineering.de" from "https://kai.marketplace.deepc-engineering.de/".
 */
export const getSecondLevelDomain = () => {
  const parsed = psl.parse(location.host) as ParsedDomain;
  return parsed.domain || location.host;
};
